import noop from 'lodash/noop';

import SidebarItem from './SidebarItem';

function SidebarActionItem(props) {
  const { onClick = noop, ...restProps } = props;
  return <SidebarItem onClick={onClick} {...restProps} />;
}

SidebarActionItem.displayName = 'SidebarActionItem';
export default SidebarActionItem;
